import { ref } from 'vue'
import { defineStore } from 'pinia'
import { TwilioError } from '@twilio/voice-sdk'

type WrappedError = {
  error: TwilioError.TwilioError
  timestamp: Date
}

export const useErrorsStore = defineStore('errors', () => {
  const errors = ref<WrappedError[]>([])

  const addError = (error: TwilioError.TwilioError) => {
    errors.value.push({ error, timestamp: new Date() })
  }

  return { addError, errors }
})
